<template>
    <div class="u-message">
        <a class="u-message__photo" :href="message.avatar.href">
            <img :src="message.avatar.src" class="avatar" :alt="message.avatar.alt">
        </a>
        <div class="u-message__body">
            <strong class="u-message__name r-strong" v-html="title"></strong>
            <div class="u-message__content">
                <p v-html="description"></p>
                <p v-if="message.canceledLink">
                    Вы также можете отменить запись. <button class="r-button pseudo-link" type="button" @click="showCancel = true">Просто нажмите здесь</button>.
                </p>
            </div>
        </div>
        <div class="u-message__action" v-if="message.button && message.button.link && message.button.type === 'info'">
            <a :href="message.button.link" class="r-link button" v-html="message.button.title"></a>
        </div>
        <div class="u-message__action" v-else-if="message.button && message.button.link && message.button.type === 'online'">
            <button @click="consultationWarning" class="form__button r-button button" v-html="message.button.title" disabled v-if="disabled"></button>
            <a :href="message.button.link" class="r-link button" v-html="message.button.title" v-else></a>
        </div>
        <div class="modal modal_is-open modal-msg" v-if="showCancel">
            <div class="modal__main">
                <button class="modal__close button-icon r-button" type="button" @click="showCancel = false">
                    <span class="screen-reader">Закройте всплывающее окно</span>
                </button>
                <strong class="modal__title modal-msg__msg r-strong">Вы уверены, что хотите отменить запись?</strong>
                <strong class="modal__title modal-msg__msg r-strong" v-if="message.button && message.button.payment && user.type === 'patient'">При отмене консультации менее чем за 8 часов до ее начала, денежные средства возврату не подлежат.</strong>
                <form method="POST" :action="message.canceledLink">
                    <div class="form__group">
                        <label class="field field_verified">
                            <span class="field__caption">Укажите причину отмены:</span>
                            <textarea required name="cancelReason" class="field__input r-text-input textarea"></textarea>
                        </label>
                    </div>
                    <div class="modal-msg__actions">
                        <input type="hidden" name="_method" value="DELETE"/>
                        <input type="hidden" name="consultation_date" :value="formStartDate()"/>
                        <input type="hidden" name="_token" :value="token"/>

                        <button class="modal-msg__action r-button button button_secondary" type="button" @click="showCancel = false">Нет</button>
                        <button class="modal-msg__action r-button button">Да, отменить запись</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs';
	import utc from 'dayjs/plugin/utc';

	dayjs.extend(utc);

	export default {
		name: 'DashboardConsultation',
		props: {
			message: {
				type: Object,
				required: true
			},
		},
		data() {
			return {
				interval: null,
				showCancel: false,
                timeNow: dayjs.createFromTimezone(this.message.timeNow, window.laravel.user.time_zone),
                timer: 3000,
                user: window.laravel.user,
                disabled: true,
				token: document.head.querySelector('meta[name="csrf-token"]').content,
			};
		},
        computed: {
			title() {
				return this.message.title.replace('[start_at]', dayjs.createFromTimezone(this.message.startAt, this.user.time_zone).format('dd, DD MMMM HH:mm'));
            },
			description() {
				return this.message.description.replace('[start_at]', dayjs.createFromTimezone(this.message.startAt, this.user.time_zone).format('dd, DD MMMM HH:mm'));
			},
        },
        methods: {
            checkDisabled() {
                if (!this.disabled) {
                    clearInterval(this.interval);
                }

                this.timeNow = this.timeNow.add(this.timer, 'milliseconds');

                if (dayjs.createFromTimezone(this.message.startAt, this.user.time_zone).diff(this.timeNow, 'second') <= 900) {
                    this.disabled = false;
                }
            },
            consultationWarning() {
                ErrorAlert.$emit('errorMessage', 'Извините, но эта запись не доступна');
            },
            formStartDate() {
                return dayjs.createFromTimezone(this.message.startAt, this.user.time_zone);
            }
        },
        beforeMount() {
            this.checkDisabled();

            this.interval = setInterval(() => {
                this.checkDisabled();
            }, this.timer);
        }
	}
</script>
